export const ROUTES = {
  ABOUT: '/info',
  WORKS: '/tervek'
};
